import { TimeEntryCategory } from "../timeEntryCategory/timeEntryCategory";

export class TimeEntryCategorySum {
  sum: number;
  count: number;
  category: TimeEntryCategory;  

  constructor(payload?: any) {
    if (payload) {
      this.sum = payload.sum;
      this.count = payload.count;
      if (payload.category) {
        this.category = new TimeEntryCategory(payload.category);
      }
    }
  }

  /**
   * creates users from a result
   * @param result Array of any
   * @returns Array of User
   */
  static createTimeEntryCategorySums(result: Array<any>): TimeEntryCategorySum[] {
    const timeEntryCategorySums = new Array<TimeEntryCategorySum>();
    if (result) {
      result.map((timeEntryCategorySum) => {
        timeEntryCategorySums.push(new TimeEntryCategorySum(timeEntryCategorySum));
      });
    }
    return timeEntryCategorySums;
  }

}

